import { HTTP as http } from '../../http'

export default {
    ActionSendIpagPaymentCredit: (data) => {
        return http.post('/ipag/creditDebitPayment', data)
    },

    ActionSendIpagPaymentBillet: (data) => {
        return http.post('/ipag/billetPayment', data)
    },

    ActionSendPagSeguroPaymentCard: (data) => {
        return http.post('/pagseguro/payment-card', data)
    },

    ActionSendPagSeguroPaymentBillet: (data) => {
        return http.post('/pagseguro/payment-billet', data)
    },

    ActionSendPayment: (data) => {
        return http.post('/payment/execute', data)
    },

    ActionGetSafraPayAntifraudConfig: (data) => {
        return http.post('/payment/safrapay/antifraud-config', data)
    },

    ActionGetSimulationYapay: (data) => {
        return http.post('/payment/simulation-yapay', data)
    },

    ActionGetSimulationPagarme: (total_amount) => {
        return http.get('/payment/simulationPagarMe?amount=' + total_amount)
    },

    ActionSendGetNetPaymentCard: (data) => {
        return http.post('/getnet/creditPayment', data)
    },

    ActionGetSimulationPagSeguro: (data) => {
        return http.post('/payment/simulation-pagseguro', data)
    },

    ActionGetPublicKeyPagSeguro: () => {
        return http.get('/payment/get-public-key')
    },

}
